export default "/images/vendor/flag-icon-css/flags/4x3/sc.svg?9ba013463b785efeb6be8cb92d335bb1";